.flare-async-content-boundary {
  display: grid;
  flex: 1;
  min-height: 0;
  min-width: 0;
}

.flare-async-content-boundary-content {
  display: flex;
  flex-direction: column;
  grid-area: 1 / 1;
  min-height: 0;
  min-width: 0;
  opacity: 1;
  transform: translateY(0);
  transition:
    opacity 180ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 240ms cubic-bezier(0.22, 1, 0.36, 1);
}

.flare-async-content-boundary-overlay {
  align-items: center;
  background: inherit;
  display: flex;
  flex-direction: column;
  gap: 10px;
  grid-area: 1 / 1;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transform: translateY(5px) scale(0.995);
  transition:
    opacity 180ms cubic-bezier(0.22, 1, 0.36, 1),
    transform 220ms cubic-bezier(0.22, 1, 0.36, 1),
    visibility 0s linear 220ms;
  visibility: hidden;
  z-index: 3;
}

.flare-async-content-boundary.is-pending.is-skeleton .flare-async-content-boundary-content {
  opacity: 0;
  pointer-events: none;
  transform: translateY(3px);
  user-select: none;
}

.flare-async-content-boundary.is-pending.is-retained .flare-async-content-boundary-content {
  opacity: 1;
  transform: none;
}

.flare-async-content-boundary.is-pending.is-retained.is-interaction-blocked .flare-async-content-boundary-content {
  pointer-events: none;
  user-select: none;
}

.flare-async-content-boundary.is-pending .flare-async-content-boundary-overlay {
  opacity: 1;
  transform: translateY(0) scale(1);
  transition-delay: 0s;
  visibility: visible;
}

.flare-async-content-boundary.is-pending.is-retained .flare-async-content-boundary-overlay {
  background: transparent;
  gap: 6px;
  justify-content: flex-start;
  padding-top: 8px;
}

.flare-async-content-boundary.is-pending.is-retained.is-interaction-blocked .flare-async-content-boundary-overlay {
  background: color-mix(in srgb, var(--flare-surface-bg, white) 76%, transparent);
  justify-content: center;
  padding-top: 0;
  pointer-events: auto;
}

.flare-async-content-boundary.is-pending.is-retained .flare-async-content-boundary-track {
  height: 2px;
}

.flare-async-content-boundary-indicator {
  align-items: center;
  animation: flareAsyncContentBreath 1.45s cubic-bezier(0.45, 0, 0.25, 1) infinite;
  display: flex;
  height: 48px;
  justify-content: center;
  transform-origin: center;
  width: 48px;
}

.flare-async-content-boundary-heading {
  color: var(--flare-text-primary, #172033);
  font-family: var(--flare-font-heading, inherit);
  font-size: 18px;
  font-weight: 650;
  letter-spacing: 0.015em;
  line-height: 1.3;
}

.flare-async-content-boundary-label {
  color: var(--flare-text-secondary, #667085);
  font-size: 13px;
  font-weight: 550;
  letter-spacing: 0.02em;
  line-height: 1.4;
}

.flare-async-content-boundary-track {
  background: color-mix(in srgb, var(--flare-accent) 14%, transparent);
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--flare-accent) 8%, transparent);
  display: block;
  height: 3px;
  overflow: hidden;
  position: relative;
  width: 112px;
}

.flare-async-content-boundary-progress {
  animation: flareAsyncContentProgress 1.2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  background: var(--flare-accent);
  background-image: linear-gradient(
    90deg,
    color-mix(in srgb, var(--flare-accent) 72%, white),
    var(--flare-accent),
    color-mix(in srgb, var(--flare-accent) 82%, white)
  );
  border-radius: inherit;
  box-shadow: 0 0 8px color-mix(in srgb, var(--flare-accent) 38%, transparent);
  display: block;
  height: 100%;
  transform: translateX(-140%);
  width: 42%;
}

@keyframes flareAsyncContentBreath {
  0%,
  100% {
    opacity: 0.58;
    transform: scale(0.94);
  }

  50% {
    opacity: 1;
    transform: scale(1.06);
  }
}

@keyframes flareAsyncContentProgress {
  0% {
    transform: translateX(-140%);
  }

  55% {
    transform: translateX(135%);
  }

  100% {
    transform: translateX(260%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .flare-async-content-boundary-content,
  .flare-async-content-boundary-overlay,
  .flare-async-content-boundary-indicator,
  .flare-async-content-boundary-progress {
    animation: none;
    transition: none;
  }
}
